import axios from "axios";
import { BASE_URL } from "./constants";
 
const METHOD = {
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete",
};
 
class API {
  constructor() {
    this.baseURL = BASE_URL;
  }
 
  async get(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.GET, url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
 
  post(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.POST, url, data)
        .then((response) => {
          if (response && response.data) {
            resolve(response)
          } else {
            reject(new Error('Request failed'))
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
  put(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.PUT, url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  patch(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.PATCH, url, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  }
  delete(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.DELETE, url, data)
        .then((response) => resolve(response))
        .catch((error) => {
          reject(error)
        })
    })
  }
  api(method, url, data) {
    return new Promise(( resolve,reject) => {
      let axiosConfig = {};
      axiosConfig.method = method;
      let cleanUrl = url.startsWith('/') ? url : `/${url}`;
      if (this.baseURL.endsWith('/api/v1') && cleanUrl.startsWith('/api/v1/')) {
        cleanUrl = cleanUrl.replace('/api/v1', '');
      }
      axiosConfig.url = this.baseURL + cleanUrl;
      axiosConfig.headers = this.setHeaders(data);
      if (data) {
        if (method.toLowerCase() === 'get') {
          axiosConfig.params = data;
        } else {
          axiosConfig.data = data;
        }
      }
 
      axios(axiosConfig)
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          const originalRequest = error.config;
          const isRefreshUrl = url.includes('/auth/refresh');
          const isAuthUrl = url.includes('/auth/login') || url.includes('/login') || url.includes('/auth/signup') || url.includes('/signup');
          const refreshToken = localStorage.getItem('refresh_token');

          // If 401 Unauthorized occurs on an authenticated resource (not auth endpoint itself)
          if (error.response?.status === 401 && !isAuthUrl && !isRefreshUrl) {
            // Attempt silent refresh if refresh_token exists and hasn't been retried yet
            if (refreshToken && !originalRequest._retry) {
              originalRequest._retry = true;
              try {
                const refreshRes = await axios.post(`${this.baseURL}/auth/refresh`, {
                  refresh_token: refreshToken
                });

                if (refreshRes.data?.success && refreshRes.data?.token) {
                  const newToken = refreshRes.data.token;
                  const newRefreshToken = refreshRes.data.refresh_token;

                  localStorage.setItem('token', newToken);
                  if (newRefreshToken) localStorage.setItem('refresh_token', newRefreshToken);

                  originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                  const retriedResponse = await axios(originalRequest);
                  return resolve(retriedResponse);
                }
              } catch (refreshErr) {
                console.error("[API] Automatic token refresh failed:", refreshErr);
              }
            }

            // If refresh fails or no refresh token is present, clean up and redirect to login
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
            if (window.location.pathname !== '/login') {
              window.location.href = '/login';
            }
          }
          reject(error);
        });
    });
  }
  setHeaders(data) {
    let headers = {};
    headers["accept-language"] = "en";
    headers["Accept"] = "application/json";
    headers["ngrok-skip-browser-warning"] = "true";
const token = localStorage.getItem("token")
    if (token) headers["Authorization"] = `Bearer ${token}`
    // For FormData let axios set Content-Type automatically (includes the multipart boundary)
    if (!(data instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }
    if (data && data.headers) {
      for (var key in data.headers) {
        if (data.headers.hasOwnProperty(key)) {
          headers[key] = data.headers[key];
        }
      }
    }
    return headers;
  }
}
export default API;
 
 
 
 
 